/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Endereco } from '../enderecos/types';

const getEnderecoPorEmpresasId = (empresasId: number): AxiosPromise<Endereco> => xhr.get(`/empresas/${empresasId}/endereco`);

export default getEnderecoPorEmpresasId;
